  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyAMYyaz1aQfX0CjHKSvLJDYME_AtKYkInE",
  authDomain: "xxx5-2aecb.firebaseapp.com",
  projectId: "xxx5-2aecb",
  storageBucket: "xxx5-2aecb.firebasestorage.app",
  messagingSenderId: "710763980848",
  appId: "1:710763980848:web:80f48f267b978a3ca365f5",
  measurementId: "G-PBJ6DNJGDM"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
